import {applicationEvents} from '@/utils/applicationEvents'
import {normalizeApiValidationErrors} from '@/utils/apiValidationErrors'

function copyValues(values) {
  return JSON.parse(JSON.stringify(values))
}

function validationErrors(error) {
  if (error?.name === 'ValidationError') {
    return (error.inner?.length ? error.inner : [error]).reduce((errors, item) => {
      errors[item.path || 'base'] = item.message
      return errors
    }, {})
  }
  const errors = normalizeApiValidationErrors(error?.response?.data)
  return Object.keys(errors).length ? errors : {base: 'Die Aktion konnte nicht ausgeführt werden. Bitte versuchen Sie es erneut.'}
}

// Forms supply publicationObject, publicationForm, persistObject and persistPublicationState.
export default {
  data() {
    return {
      publicationBusy: false,
      publicationErrors: {},
      publicationMessage: '',
      // Follow-up question after publishing on the client's website; see MarketingPromptDialog.
      marketingPrompt: null,
    }
  },
  computed: {
    publicationContextReady() {
      return true
    },
    // Completeness is checked only by an explicit activation action, never by saving.
    saveSchema() {
      return this.schema.pick(['name'])
    },
    publicationState() {
      const enabled = !!this.publicationObject?.enabled
      return {
        enabled,
        setting_enable_in_manet_stadt_abl: enabled && !!(this.publicationObject?.setting_enable_in_manet_stadt_abl ?? enabled),
      }
    },
  },
  methods: {
    saveObject(values) {
      return this.runPublicationAction('save', values)
    },
    async runPublicationAction(action, values) {
      if (this.publicationBusy) return
      this.publicationBusy = true
      this.publicationErrors = {}
      this.publicationMessage = ''
      let saved = false
      const form = this.publicationForm
      try {
        if (action === 'deactivate' || action === 'stop-marketing') {
          const state = action === 'deactivate' || !this.showPortalToggle
            ? {enabled: false, setting_enable_in_manet_stadt_abl: false}
            : {...this.publicationState, setting_enable_in_manet_stadt_abl: false}
          // Deactivation changes only the persisted state, not unsaved form contents.
          await this.persistPublicationState(state)
          Object.entries(state).forEach(([field, value]) => form.setFieldValue(field, value, false))
          form.setErrors({})
          applicationEvents.emit('success', action === 'stop-marketing' && this.showPortalToggle ? 'Von mvp.de entfernt' : 'Offline genommen')
          return
        }

        if (action !== 'save' && !this.publicationContextReady) {
          form.setErrors({base: 'Die Website-Informationen müssen vor dem Veröffentlichen geladen werden. Bitte laden Sie die Seite erneut.'})
          return
        }
        if (action === 'activate-marketing' && this.showPortalToggle && !this.publicationState.enabled) {
          form.setErrors({base: 'Bitte veröffentlichen Sie den Eintrag zuerst auf Ihrer Website.'})
          return
        }
        let draft = await this.saveSchema.validate(copyValues(values), {abortEarly: false})
        draft = {...draft, ...this.publicationState}
        const locationResult = await this.$refs.hostLocationSelector.prepareSubmit(draft, {requireLocation: false})
        if (!locationResult.ok) {
          form.setErrors(locationResult.errors)
          return
        }
        await this.persistObject(draft)
        saved = true

        if (action === 'save') {
          applicationEvents.emit('success', this.publicationState.enabled ? 'Gespeichert' : 'Entwurf gespeichert')
          return
        }

        // Use the saved values: newly created nested records now have their server IDs.
        const target = {
          ...copyValues(form.getValues()),
          enabled: true,
          setting_enable_in_manet_stadt_abl: action === 'activate-marketing',
        }
        const validated = await this.schema.validate(target, {abortEarly: false})
        const activationLocation = await this.$refs.hostLocationSelector.prepareSubmit(validated)
        if (!activationLocation.ok) {
          this.showActivationErrors(activationLocation.errors, action)
          return
        }
        await this.persistObject(validated)
        if (action === 'activate-website') {
          // The dialog itself confirms the publication and offers mvp.de as the next step.
          this.marketingPrompt = 'published'
        } else {
          applicationEvents.emit('success', 'Auf mvp.de veröffentlicht')
        }
      } catch (error) {
        const errors = validationErrors(error)
        if (saved) {
          this.showActivationErrors(errors, action)
        } else {
          form.setErrors(errors)
        }
      } finally {
        this.publicationBusy = false
      }
    },
    showActivationErrors(errors, action) {
      this.publicationErrors = errors
      this.publicationMessage = action === 'activate-website'
        ? 'Ihre Änderungen wurden gespeichert. Zum Veröffentlichen fehlen noch Angaben. Bitte ergänzen oder korrigieren Sie:'
        : 'Ihre Änderungen wurden gespeichert. Für die Veröffentlichung auf mvp.de fehlen noch Angaben. Bitte ergänzen oder korrigieren Sie:'
      this.publicationForm.setErrors(errors)
    },
  },
}
